module.exports = __webpack_public_path__ + "static/media/icons-export-data.fd489982.svg";